
import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { ProviderFormComponent } from '@/pages/providers/provider-form/provider-form.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './provider-list.page.html',
  styleUrl: './provider-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ProviderListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  public url = Urls.urls.providers;

  public headers = [
    { name: 'Número', key: 'id_by_company' },
    { name: 'NOMBRE', key: 'name' },
    { name: 'FECHA CREACIÓN', key: 'created_at', type: 'dateTime' },
    { name: 'FECHA ACTUALIZACIÓN', key: 'updated_at', type: 'dateTime' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(ProviderFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'proveedor';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
